import { jsx as _jsx } from "react/jsx-runtime";
import AssetComponent from "components/core/asset/asset-component";
import classnames from "classnames";
import { StyledAnimatedIcon } from "./animated-icon.scss";
const AnimatedIcon = (props)=>{
    const { iconAsset, animationDuration, initialOffset, startAnimation } = props;
    return /*#__PURE__*/ _jsx(StyledAnimatedIcon, {
        className: classnames("animated-icon", {
            "fall-in-animation": startAnimation
        }),
        animationDuration: animationDuration,
        initialOffset: initialOffset,
        children: /*#__PURE__*/ _jsx(AssetComponent, {
            image: {
                src: iconAsset
            }
        })
    });
};
export default AnimatedIcon;
